import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'
import { Typography } from '@homeviews/shared-ui'
import { maybePlaceholderImage } from '@homeviews/utils'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      margin: 2,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    selected: {},
    body: {
      flex: 1,
    },
    title: {
      marginTop: 12,
      marginBottom: 5,
      color: '#4E516B',
    },
    meta: {},
    tickWrapper: {
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 1,
      width: 30,
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.colors.primary,
      opacity: 0,

      '& > img': {
        width: 21,
      },
    },
    imageWrapper: {
      height: 0,
      borderRadius: 3,
      position: 'relative',
      overflow: 'hidden',
      paddingBottom: `${(180 / 238) * 100}%`,
      zIndex: 2,
      '& > img': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    imageWrapperSelected: {
      zIndex: 2,
      boxShadow: `0 0 0 2px ${theme.colors.primary}`,
    },
    tickWrapperSelected: {
      opacity: 1,
    },
  }),
)

const MediaCard: FC<any> = ({
  className,
  handleClick,
  selected,
  mediaItem,
}) => {
  const classes = useStyles()

  const onCardClick = () => {
    handleClick(mediaItem.id)
  }

  return (
    <div
      className={clsx(classes.root, selected && classes.selected, className)}
      onClick={onCardClick}
    >
      <div
        className={clsx(
          classes.imageWrapper,
          selected && classes.imageWrapperSelected,
        )}
      >
        <img
          src={maybePlaceholderImage(mediaItem.url)}
          alt={`${mediaItem.name || ''}`}
        />
        <div
          className={clsx(
            classes.tickWrapper,
            selected && classes.tickWrapperSelected,
          )}
        >
          <img src="assets/icons/medium/tick.svg" alt="tick" />
        </div>
      </div>
      <div className={classes.body}>
        <Typography variant="h5" className={classes.title}>
          {mediaItem.name || mediaItem.file_name}
        </Typography>
        <div className={classes.meta}>
          {mediaItem.ext?.toUpperCase() || mediaItem.type} |{' '}
          {mediaItem.size || mediaItem.file_size}
        </div>
      </div>
    </div>
  )
}

export default MediaCard
